import {Editor} from '@tiptap/react';
import {
    EDITOR_MODE,
    EditorActionTypes,
    EditorModeType,
    REMOVE_EDITOR,
    SET_DEBOUNCE_CHANGE_HANDLER,
    SET_EDITOR,
} from '../actions/types/tiptapEditor.types';

export interface EditorState {
    editors: Record<string, Editor>;
    debounceChangeHandlers: Record<string, (updatedContent: string) => void>;
    editorMode: EditorModeType | null;
}

export const editorPreloadedState: EditorState = {
    editors: {},
    debounceChangeHandlers: {},
    editorMode: null,
};

const editorReducer = (state: EditorState = editorPreloadedState, action: EditorActionTypes): EditorState => {
    switch (action.type) {
        case SET_EDITOR:
            return {
                ...state,
                editors: {
                    ...state.editors,
                    [action.payload.id]: action.payload.editor,
                },
            };
        case REMOVE_EDITOR: {
            if (state.editors[action.payload.id] !== action.payload.editor) return state;
            const editors = Object.fromEntries(Object.entries(state.editors).filter(([id]) => id !== action.payload.id));
            return {...state, editors};
        }
        case SET_DEBOUNCE_CHANGE_HANDLER:
            return {
                ...state,
                debounceChangeHandlers: {
                    ...state.debounceChangeHandlers,
                    [action.payload.id]: action.payload.handler,
                },
            };
        case EDITOR_MODE:
            return {
                ...state,
                editorMode: action.payload.mode,
            };
        default:
            return state;
    }
};

export default editorReducer;
